import { ChangeDetectionStrategy, Component, output, signal, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MewsPmsSetup, PmsType } from '../../../../../types/pms';

@Component({
    selector: 'juyo-mews-connect',
    styleUrl: './mews.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule],
    template: `
        <h3 class="step-title">Connect to Mews</h3>
        <p class="step-subtitle">
            Paste your Mews API token to start pulling property data. You can also skip this and add it later from the
            property's Manage panel.
        </p>

        <div class="field">
            <label class="field-label" for="property-token">MEWS API TOKEN</label>
            <input
                id="property-token"
                type="text"
                class="field-input"
                placeholder="Paste your Mews API token here"
                [ngModel]="apiToken()"
                (ngModelChange)="onTokenChange($event)"
            />
        </div>

        <button
            type="button"
            class="token-help-toggle"
            (click)="showTokenHelp.set(!showTokenHelp())"
            [attr.aria-expanded]="showTokenHelp()"
            aria-controls="token-help-panel"
        >
            <span class="material-symbols-outlined">help</span>
            Where do I find the token?
        </button>

        @if (showTokenHelp()) {
            <div class="token-help-panel" id="token-help-panel">
                <p class="token-help-title">How to get your Mews API token</p>
                <ol class="token-help-steps">
                    <li>Log in to <strong>Mews Operations</strong></li>
                    <li>Open <strong>Main Menu → Marketplace</strong></li>
                    <li>Search for <strong>Juyo</strong> in the Marketplace</li>
                    <li>Click <strong>Connect</strong> to enable the integration</li>
                    <li>Copy the <strong>generated API token</strong></li>
                    <li>Paste the token in the field above</li>
                </ol>
            </div>
        }
    `,
})
export class MewsConnectComponent {
    public valueChange = output<MewsPmsSetup | null>();

    protected apiToken = signal('');
    protected showTokenHelp = signal(false);

    private isValid = computed(() => this.apiToken().length >= 10);

    protected onTokenChange(value: string): void {
        this.apiToken.set(value);
        this.valueChange.emit(this.isValid() ? { type: PmsType.Mews, apiToken: value } : null);
    }
}
